import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

export const ControlPanelCheckbox = ({
  handleChange,
  optionChecked,
  target,
  label,
}) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={optionChecked}
          onChange={(e) => handleChange(target, e.target.checked)}
          sx={{
            color: "primary.main",
            "&.Mui-checked": { color: "primary.light" },
          }}
        />
      }
      label={label}
    />
  );
};
